const pdfOrdenDigitalInitialState = {
  pdfOrdenDigital: {
    loading: false,
    error: null,
    data: null,
  },
};

export default pdfOrdenDigitalInitialState;
